import styled, { css } from 'styled-components'

interface IStateProps {
  color: string
  height: number
}

export const State = styled.div`
  ${(props: IStateProps) =>
    css`
      height: ${props.height}px;
    `}
  display: flex;
  align-items: center;
  svg {
    ${(props: IStateProps) =>
      css`
        color: ${props.color};
      `}
    font-size: 10px !important;
    margin-right: 8px;
  }
`
